import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const ProductCard = ({ product, index = 0, large = false }) => {
  const stock = product.stock ?? 10;
  const isSoldOut = stock === 0;
  const isLimitedEdition = stock > 0 && stock <= 5;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
    >
      <Link
        to={`/product/${product.slug || product.id}`}
        data-testid={`product-card-${product.id}`}
        className={`product-card group block ${large ? 'row-span-2 col-span-2' : ''}`}
      >
        {/* Image Container */}
        <div className={`relative overflow-hidden bg-neutral-100 ${large ? 'aspect-square' : 'aspect-square'}`}>
          {product.images && product.images[0] ? (
            <img
              src={product.images[0]}
              alt={product.name}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-neutral-300">
              No Image
            </div>
          )}

          {/* Sold Out Diagonal Line */}
          {isSoldOut && (
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute top-0 left-0 w-full h-full">
                <svg className="w-full h-full" preserveAspectRatio="none">
                  <line x1="0" y1="100%" x2="100%" y2="0" stroke="black" strokeWidth="1" />
                </svg>
              </div>
            </div>
          )}

          {/* Overlay */}
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-500" />

          {/* View Button */}
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            <span className="bg-white text-black px-6 py-3 text-sm font-semibold uppercase tracking-wider shadow-lg">
              {isSoldOut ? 'View Details' : 'View Details'}
            </span>
          </div>

          {/* Badges Container - Top Left */}
          <div className="absolute top-4 left-4 flex flex-col gap-2">
            {/* Featured Badge */}
            {product.featured && (
              <span className="bg-[#e84628] text-white px-3 py-1 text-xs font-semibold uppercase tracking-wider">
                Featured
              </span>
            )}
            
            {/* Sold Out Badge */}
            {isSoldOut && (
              <span className="bg-neutral-800 text-white px-3 py-1 text-xs font-semibold uppercase tracking-wider">
                Sold Out
              </span>
            )}
            
            {/* Limited Edition Badge */}
            {isLimitedEdition && (
              <span className="bg-amber-500 text-white px-3 py-1 text-xs font-semibold uppercase tracking-wider">
                Limited Edition
              </span>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="p-4 md:p-6">
          <h3 className="font-semibold text-base md:text-lg tracking-tight line-clamp-1 group-hover:text-neutral-600 transition-colors">
            {product.name}
          </h3>
          <div className="flex items-center justify-between mt-2">
            <p className="text-neutral-400 text-sm">
              {product.movie_reference || 'Sculpture'}
            </p>
            <p className="font-semibold">
              £{product.price.toFixed(2)}
            </p>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
